export const blockFooter = `
          <table
            cellspacing="0"
            id="imo7"
            style="
              box-sizing: border-box;
              height: 150px;
              width: 100%;
              cellspacing: 0;
            "
            width="100%"
            height="150"
          >
            <tbody style="box-sizing: border-box">
              <tr style="box-sizing: border-box">
                <td
                  title="column"
                  id="ih9w"
                  style="
                    box-sizing: border-box;
                    padding: 0;
                    margin: 0;
                    vertical-align: top;
                    width: 10px;
                    height: 10px;
                  "
                  width="10"
                  height="10"
                  valign="top"
                >
                  <div id="iouz" style="box-sizing: border-box; margin-top: 10px;">
                    <span
                      id="im6da"
                      style="
                        box-sizing: border-box;
                        font-size: 12pt;
                        font-family: 'Times New Roman', serif;
                        mso-fareast-font-family: Calibri;
                        mso-fareast-theme-font: minor-latin;
                        color: #201f1e;
                        mso-ansi-language: EN-US;
                        mso-fareast-language: EN-US;
                        mso-bidi-language: AR-SA;
                      "
                    >Thanks &amp; Best regards</span
                    >
                  </div>
                  <div id="i4afj" style="box-sizing: border-box">
                    <p
                      class="MsoNormal"
                      id="ic9ls"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <span
                        id="ialbc"
                        style="
                          box-sizing: border-box;
                          font-family: 'Times New Roman', serif;
                          color: #201f1e;
                        "
                      >-----------------------------</span
                      ><o:p style="box-sizing: border-box"></o:p>
                    </p>
                  </div>
                  <div id="ijndp" style="box-sizing: border-box"></div>
                  <div id="iv9af" style="box-sizing: border-box"></div>
                  <img
                    id="iu25s"
                    src="data:image/png;base64,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"
                    style="
                      box-sizing: border-box;
                      color: black;
                      width: 201px;
                      height: 56px;
                    "
                    width="201"
                    height="56"
                  />
                  <div id="iftcl" style="box-sizing: border-box">
                    <p
                      class="MsoNormal"
                      id="itppy"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        id="i6n9z"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #ff5407;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                          "
                      >Tran Thi Huyen</span
                        ></b
                      ><span
                        id="iibzf"
                        style="box-sizing: border-box; font-size: 12pt"
                      ><o:p style="box-sizing: border-box"></o:p
                      ></span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="iftqh"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        id="iwxfj"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #ff5407;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                          "
                      >HR Staff
                        </span></b
                      ><span
                        id="iy96e"
                        style="
                          box-sizing: border-box;
                          font-size: 12pt;
                          font-family: 'Times New Roman', serif;
                          color: #262626;
                          border: none windowtext 1pt;
                          mso-border-alt: none windowtext 0in;
                          padding: 0in;
                        "
                      > | <b style="box-sizing: border-box"
                      >HR Department</b
                        ></span
                      ><span
                        id="itrmq"
                        style="box-sizing: border-box; font-size: 12pt"
                      ><o:p style="box-sizing: border-box"></o:p
                      ></span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="i10yf"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        id="i7lqj"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #262626;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                          "
                      >Cell Phone: </span
                        ></b
                      >
                      <span>xxxxxxxxxxxxxxx</span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="invym"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        id="i00dl"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #262626;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                          "
                      >Email: </span
                        ></b
                      ><span>xxxxxxxxxxxxxxx</span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="ic98h"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        lang="VI"
                        id="idotf"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #f25928;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                            mso-ansi-language: VI;
                          "
                      >----------------------------------------</span
                        ></b
                      ><span
                        id="iz7me"
                        style="box-sizing: border-box; font-size: 12pt"
                      ><o:p style="box-sizing: border-box"></o:p
                      ></span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="ihn8o"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        lang="VI"
                        id="i98dw"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #f25928;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                            mso-ansi-language: VI;
                          "
                      >INNOTECH VIETNAM CORPORATION</span
                        ></b
                      ><span
                        id="ijjqh"
                        style="box-sizing: border-box; font-size: 12pt"
                      ><o:p style="box-sizing: border-box"></o:p
                      ></span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="ierqv"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        id="if6xv"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #262626;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                          "
                      >Head office: </span
                        ></b
                      >
                       <span>xxxxxxxxxxxxxxx</span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="i25c5"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        lang="VI"
                        id="iz41g"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #262626;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                            mso-ansi-language: VI;
                          "
                      >Hotline: </span
                        ></b
                      >
                       <span>xxxxxxxxxxxxxxx</span>
                    </p>
                    <p
                      class="MsoNormal"
                      id="ijkn3"
                      style="
                        box-sizing: border-box;
                        margin: 0 0 0 0;
                        background-image: initial;
                        background-position: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                      "
                    >
                      <b style="box-sizing: border-box"
                      ><span
                        id="i8swj"
                        style="
                            box-sizing: border-box;
                            font-size: 12pt;
                            font-family: 'Times New Roman', serif;
                            color: #262626;
                            border: none windowtext 1pt;
                            mso-border-alt: none windowtext 0in;
                            padding: 0in;
                          "
                      >Website: </span
                        ></b><span>xxxxxxxxxxxxxxx</span>
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>`;
